import type React from "react";
import About from "../components/About";
import AppDownload from "../components/AppDownload";
import Hero from "../components/Hero";
import Seo from "../components/Seo";

const Home: React.FC = () => {
  return (
    <>
      <Seo
        title="Boutique Indoor Cycling Studio in Saskatoon"
        description="Saskatoon's boutique indoor cycling studio offering rhythm-based spin classes for all levels. Book a class at 2710 Lorne Avenue."
        path="/"
      />
      <Hero />
      <div>
        <About />
        {/* <AppDownload /> */}
      </div>
    </>
  );
};

export default Home;
